"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class DatabaseHelper {
    static async MobileQuery(query, params) {
        let con = __1.Config.GetSqlInstance();
        return con.executeSql(query, params);
    }
    static async CliQuery(query, params, needs_result) {
        let con = __1.Config.GetSqlInstance();
        if (needs_result) {
            return con.all(query, params);
        }
        else {
            return con.run(query, params);
        }
    }
    static async Query(query, params) {
        if (__1.Config.IS_CLI) {
            let needs_result = false;
            if (query.indexOf('select') > -1) {
                needs_result = true;
            }
            return this.CliQuery(query, params, needs_result);
        }
        else {
            return this.MobileQuery(query, params);
        }
    }
    static ConvertResultSetToArray(sql_res) {
        if (__1.Config.IS_CLI) {
            return sql_res;
        }
        else {
            let result = [];
            if (sql_res && sql_res.rows && sql_res.rows.length > 0) {
                for (let i = 0; i < sql_res.rows.length; i++) {
                    let item = sql_res.rows.item(i);
                    result.push(item);
                }
            }
            return result;
        }
    }
    static ConvertResultSetToObject(sql_res) {
        if (__1.Config.IS_CLI) {
            if (sql_res && sql_res.length > 0) {
                return sql_res[0];
            }
        }
        else {
            if (sql_res && sql_res.rows && sql_res.rows.length > 0) {
                return sql_res.rows.item(0);
            }
        }
    }
}
exports.default = DatabaseHelper;
